/**
 * This file defines app-wide constants. Please make everything that makes sense
 * (e.g. might differ between local, staging, prod) available as environment variable.
 * The default value should be the one used for local development.
 *
 * NOTE: The name always has to start with VITE_APP_ or is ignored by react
 */
const defaultSettings = {
  VITE_APP_API_URL: 'http://localhost:8000/api/v1/',
  VITE_APP_ROUTER_BASE_NAME: '',
  VITE_APP_NAME: '',
  VITE_APP_LANGUAGE_COOKIE_NAME: 'i18next',

  // Settings for Single Sing-on
  VITE_APP_LOGIN_SSO_PROVIDER: '',
  // Azure Active Directory Authentication Library (ADAL) settings
  VITE_APP_ADAL_TENANT: '',
  VITE_APP_ADAL_CLIENT_ID: '', // Azure SSO Client ID for test env
  VITE_APP_ADAL_API_ENDPOINT: '',
  VITE_APP_ADAL_REDIRECT_URI: undefined,
  // Google Authentication Library settings
  VITE_APP_GOOGLE_CLIENT_ID:
    '634852946509-opv3r01mtqduid58m86kgal5q2ptgisa.apps.googleusercontent.com', // Google SSO Client ID for test env
  VITE_APP_LOGIN_ERROR_HELP_URL: '',

  // after this amount of milliseconds the auth token will be removed
  // and the user will be redirected back to the login page unless the
  // user is active by selecting a different org unit in the tree
  VITE_APP_SESSION_TIME: 1000 * 60 * 30,

  VITE_APP_CONTACT_EMAIL_ADDRESS: '',

  VITE_APP_PAGINATION_THRESHOLD_USER_LIST: 100,
  VITE_APP_API_RESULT_LIMITS_SEARCH: 500,

  VITE_APP_SENTRY_DSN: '',
  VITE_APP_SENTRY_RELEASE: '',
  VITE_APP_SENTRY_ENVIRONMENT: '',

  // Used for enabling follow up ticket users to access my follow up
  VITE_APP_IS_MY_FOLLOW_UP_UNLOCKED: '',
  VITE_APP_IS_SURVEY_TABLE_VIEW_UNLOCKED: '',
};

const envSettings = {
  ...import.meta.env,
  ...window.env,
};

// We overwrite all settings with the environment variables or window-level
// environment variables (see ../scripts/env.generate.js)
const settings: typeof defaultSettings = {
  ...defaultSettings,
  ...envSettings,
};

export default settings;
